import { observer } from 'mobx-react-lite';
import React from 'react';
import { LeadsForm } from '../..';
import { useLeadsForm } from '../../hooks/use-leads-form';
export const LeadsFormDetailed = observer(({ onCancel, onSubmit, lead, status, initialData, isSending, withStatus }) => {
    const { form, appendCustomerPhone, removeCustomerPhone, appendThirdPartyAgentPhone, removeThirdPartyAgentPhone } = useLeadsForm(lead, status, initialData);
    return (<LeadsForm form={form} isSending={isSending} appendCustomerPhone={appendCustomerPhone} removeCustomerPhone={removeCustomerPhone} appendThirdPartyAgentPhone={appendThirdPartyAgentPhone} removeThirdPartyAgentPhone={removeThirdPartyAgentPhone} status={status} onCancel={onCancel} onSubmit={onSubmit} withStatus={withStatus}/>);
});
